<template>
  <b-row>
    <b-col
      cols="12"
      md="4"
    >
      <b-form-group
        label="Cari Permission"
      >
        <v-select
          v-model="selected"
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          label="name"
          :options="permissionsList"
          :selectable="(option) => option.name !== findDisable(option.name)"
          @close="$store.commit('permission/RESET_PERMISSION_LIST')"
          @search="onSearchPermission"
          @input="onSelect"
        />
      </b-form-group>
    </b-col>

    <b-col
      v-if="!isLoading && list.length"
      cols="12"
    >
      <hr>

      <validation-observer ref="simpleRules">
        <b-table
          ref="refPermissionsListTable"
          :items="list"
          responsive
          :fields="tableFields"
          primary-key="id"
          show-empty
          empty-text="Belum menambahkan permission"
          class="position-relative"
        >

          <!-- Column: Name -->
          <template #cell(name)="data">
            {{ data.item.permission }}
          </template>

          <!-- Column: Guard Name -->
          <template #cell(manage)="data">
            <validation-provider
              #default="{ errors }"
              name="Nama"
              rules="required"
            >
              <div class="d-flex">
                <b-form-radio
                  v-model="data.item.action"
                  :name="`action${data.index}`"
                  value="read"
                  class="mr-1"
                  @change="onChangeAction('read', data)"
                >
                  Read
                </b-form-radio>
                <b-form-radio
                  v-model="data.item.action"
                  :name="`action${data.index}`"
                  value="manage"
                  @change="onChangeAction('manage', data)"
                >
                  Manage
                </b-form-radio>
              </div>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </template>

          <!-- Column: Actions -->
          <template #cell(actions)="data">
            <b-button
              v-ripple.400="'rgba(40, 199, 111, 0.15)'"
              variant="flat-danger"
              class="btn-icon"
              @click="deletePermission(data)"
            >
              <feather-icon icon="TrashIcon" />
            </b-button>
          </template>

        </b-table>
      </validation-observer>
    </b-col>

    <b-col
      v-if="isLoading"
      cols="12"
    >
      <b-skeleton-table
        :rows="5"
        :columns="4"
      />
    </b-col>

    <b-col
      v-if="!isLoading && !list.length"
      cols="12"
    >
      Belum ada permission ditambahkan
    </b-col>
  </b-row>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'

import {
  BSkeletonTable,
  BButton,
  BTable,
  BRow,
  BCol,
  BFormGroup,
  BFormRadio,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'

import { ValidationProvider, ValidationObserver } from 'vee-validate'
// Vee Validate
import { required } from '@validations'
import vSelect from 'vue-select'

export default {
  name: 'RolesPermissionsForm',
  components: {
    BSkeletonTable,
    BButton,
    BTable,
    BRow,
    BCol,
    BFormGroup,
    BFormRadio,

    ValidationProvider,
    ValidationObserver,
    vSelect,
  },
  directives: {
    Ripple,
  },
  props: {
    form: {
      type: Object,
      default: () => ({}),
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      required,
      tableFields: [
        { key: 'name', label: 'Nama' },
        { key: 'manage', label: 'Akses', thStyle: { width: '30%' } },
        { key: 'actions', label: '', thStyle: { width: '1%' } },
      ],
      list: [],
      selected: '',
      isPending: false,
    }
  },
  computed: {
    ...mapState('permission', ['permissions']),
    ...mapState('roles', ['isLoading']),
    ...mapGetters('permission', ['permissionsList']),
    roleId() {
      if (this.isEdit) return this.form.id
      return ''
    },
  },
  watch: {
    form() {
      this.list = this.form.permissions
    },
  },
  methods: {
    ...mapActions('permission', [
      'getPermissionList',
    ]),
    ...mapActions('roles', [
      'addPermissionToRole',
      'deletePermissionFromRole',
    ]),
    async deletePermission(data) {
      const res = await this.deletePermissionFromRole({ roleId: data.item.role_id, permissionId: data.item.permission_id })
      if (!res) this.list.splice(data.index, 1)
    },
    async onSelect(data) {
      const response = await this.addPermissionToRole({ roleId: this.roleId, permissionId: data.id, action: 'read' })
      if (response) this.list.push(response)
      this.selected = ''
    },
    async onChangeAction(value, data) {
      const currentValue = value === 'read' ? 'manage' : 'read'
      const res = await this.addPermissionToRole({ roleId: this.roleId, permissionId: data.item.permission_id, action: value })
      if (!res) this.list[data.index].action = currentValue
    },
    async onSearchPermission(keyword, loading) {
      if (keyword.length) {
        loading(true)
        this.searchPermission(loading, keyword, this)
      }
    },
    searchPermission: _.debounce((loading, search, that) => {
      that.getPermissionList({ keyword: search }).finally(() => {
        loading(false)
      })
    }, 500),
    findDisable(name) {
      const data = this.list.find(el => el.permission === name)
      if (data) {
        return data.permission
      }
      return ''
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
